<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="医生姓名">
              <a-input placeholder="请输入医生姓名" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('doctor_account')">导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <span style="float:right;">
          <a @click="loadData()"><a-icon type="sync" />刷新</a>
        </span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">


        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">提现信息</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">查看明细</a>
              <a-divider type="vertical" />
          <a @click="handleIndex(record)">账单详情</a>
            <a-divider type="vertical" />
           <span v-if="record.balance > 0">
               <a-button  @click="but(record)"> 全部提现 </a-button>
          </span>
          <span v-else>
<!--                 <a-button @click="but(record,$event)">提现中</a-button>-->
          </span>
        </span>
      </a-table>
    </div>

    <daccount-index-modal ref="modalIndx" ></daccount-index-modal>
    <doctor-account-modal ref="modalForm" @ok="modalFormOk"></doctor-account-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DoctorAccountModal from './DaccountModal'
  import { getAction, postAction, putAction } from '@/api/manage'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import pick from 'lodash.pick'
  import ImgDragSort from '@views/jeecg/ImgDragSort'
  import JFormContainer from '@comp/jeecg/JFormContainer'
  import JDate from '@comp/jeecg/JDate'
  import JImageUpload from '@comp/jeecg/JImageUpload'
  import  DaccountIndexModal from '../daccount/modules/DaccountIndexModal'



  export default {
    name: 'DoctorAccountList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DoctorAccountModal,
      ImgDragSort,
      JFormContainer,
      JDate,
      JImageUpload,
      DaccountIndexModal
    },
    data () {
      return {
        description: 'doctor_account管理页面',
        AgingDevice:[],
        // 表头
        columns: [
          {
            title:'医生ID',
            align:"center",
            dataIndex: 'doctorId'
          },
          {
            title:'医生姓名',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'累计收入（元）',
            align:"center",
            dataIndex: 'totalAmount'
          },
          {
            title:'账户余额',
            align:"center",
            dataIndex: 'balance'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/daccount/doctorAccount/list",
          delete: "/daccount/doctorAccount/delete",
          all   :   "/carry/withdrawRecord/withdrawalAll",
          deleteBatch: "/daccount/doctorAccount/deleteBatch",
          exportXlsUrl: "/daccount/doctorAccount/exportXls",
          importExcelUrl: "daccount/doctorAccount/importExcel",


        },
        dictOptions:{},
      }
    },
    created() {
      this.but( this.id );
    },


    headers:{},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      handleIndex(record){
        this.$refs.modalIndx.open(record);
      },


  but(e,event){
        let param = { };
        param.id = e.doctorId;
        // event.currentTarget.innerHTML = "提现中";

        postAction(this.url.all,param).then(res=>{
          if(res){
            this.$message.success(res.result.message);
            this.reload()
          }else{
            this.$message.warning(res.result.message)

          }

        })
      },


    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';



</style>